module.exports = __webpack_public_path__ + "static/media/PPTX.075ef253.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/PPTX.svg
// module id = 1688
// module chunks = 17